document.addEventListener('DOMContentLoaded', function () {
  // Duplicate marquee content for a seamless scrolling loop
  document.querySelectorAll('.vina-marquee').forEach(function (m) {
    if (!m.dataset.doubled) {
      m.innerHTML += m.innerHTML;
      m.dataset.doubled = 'true';
    }
  });

  // Fade/slide elements up into view as the user scrolls
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  document.querySelectorAll('.vina-reveal').forEach(function (el) {
    io.observe(el);
  });
});
